export default __webpack_public_path__ + "static/media/help_outline_black_24dp.c19e7e4e.png";